export const navigationCardWithDetails = {
  "en-US": {
    button_default: "See More Info",
  },
};

export default navigationCardWithDetails;
